<template>
  <v-sheet
    outlined
    class="pa-0 pb-5 h-100"
    style="border-top: 0px; margin-left: -1px"
  >
    <div class="text-overline text-secondary pt-3 pl-5">
      {{ title }}
    </div>
    <span class="text-h4 pl-5">
      {{ count }}
    </span>

    <v-expand-transition leave-absolute>
      <div v-show="showDetails">
        <v-divider class="mt-5 mb-5 mx-5" />
        <v-simple-table
          v-if="listValues.length > 0"
          class="mx-5"
          dense
        >
          <thead>
            <tr>
              <td
                v-for="(t, i) in listTitles"
                :key="i"
                :style="i === 0 ? 'min-width: 55%': ''"
                :class="['font-weight-medium', {'px-2 text-center': i>0}]"
              >
                {{ t }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(v, i) in listValues"
              :key="i"
            >
              <td>
                <v-icon
                  v-if="v.color"
                  x-small
                  :color="v.color"
                  style="padding-bottom: 1px"
                >
                  mdi-circle
                </v-icon> {{ v.text }}
              </td>
              <td class="font-weight-medium text-center">
                {{ v.guests }}
              </td>
              <td class="font-weight-medium text-center">
                {{ v.reservations }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div
          v-else
          class="text-center"
        >
          <span class="text--secondary subtitle-1">{{ noValuesLabel }}</span>
        </div>
      </div>
    </v-expand-transition>
  </v-sheet>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'NumericListCard',
  components: { },
  props: {
    title: { type: String, required: true },
    count: { type: String, required: true },
    listTitles: { type: Object as PropType<Array<string>>, required: true },
    listValues: {
      type: Object as PropType<Array<{text: string, guests: number, reservations: number, color?:string}>>,
      required: true,
    },
    noValuesLabel: { type: String, required: false, default: '' },
    showDetails: { type: Boolean, required: false, default: false },
  },
  data() {
    return { };
  },
  computed: { },
  mounted() { },
  methods: { },
});

</script>
